import React, { Component } from 'react';
import { observer } from 'mobx-react';
import Button from '../../components/button/Button';
import './upgrade-frank.scss';
import { upgradeGeo } from '../../service/command';
import { downloadUpgradeFile } from '../../native-interact/native-interface';
import { transformTime } from '../../js/utils';
import Progress from '../../components/progress/index';
import { upgradeStore } from '../../mobx/stores/upgrade';
import { cmdLogManager } from '../../native-interact/RFBluetooth';

cmdLogManager.use(function (logContent, next) {
  // console.log('升级后监听日志重启消息：', logContent);
  if (logContent.indexOf('frank.mode') >= 0) {
    // CPU1重启完成
    console.log('CPU1重启完成');
    upgradeStore.isRebootCPU1 = true; // CPU1重启成功
  }
  next();
});

class UpgradeFrank extends Component {
  componentWillUnmount() {
    if (this.props.store.status !== 'loading') {
      clearInterval(this.timer);
    }

    // 卸载异步操作设置状态
    this.setState = () => {
      return null;
    };
  }

  onUpgrade = () => {
    // 进行此操作的前提是已经判断地磁需要升级 直接下载文件进行升级操作
    console.log('开始升级CPU1');
    this.startDownloadUpgradeFile('cpu1');
  }

  startDownloadUpgradeFile = (cpuType) => {
    this.props.store.module = cpuType;
    const { downloadUrl, MD5 } = this.props.store;
    downloadUpgradeFile(cpuType, downloadUrl, MD5).then(() => {
      this.props.store.status = 'loading';
      upgradeGeo(cpuType, 'bt').then(() => {
        // 升级中
        this.props.store.startTime = new Date();
        this.startCount();
      }).catch(() => {
        this.props.store.status = 'fail';
      });
    }).catch(() => {
      console.log('下载升级文件失败');
      this.props.store.module = '';
    });
  }

  startCount = () => {
    this.timer = setInterval(() => {
      const { startTime } = this.props.store;
      if (!startTime) {
        clearInterval(this.timer);
      } else {
        this.props.store.spendTime = transformTime(Date.now() - startTime);
      }
    }, 1000);
  }

  skip = () => {
    if (this.timer) {
      clearInterval(this.timer);
    }
    this.props.onhideUpgrade();
  }

  render() {
    const { showUpgrade, upGradeType, store } = this.props;
    const {
      version, newVersion, progress, status, module, isRebootCPU1
    } = store;
    let titleTxt = `${module}地磁版本低于服务器最新版本，请先升级`;
    const statusComp = (() => {
      console.log('CPU1重启状态', isRebootCPU1);
      if (isRebootCPU1) {
        titleTxt = '升级重启已完成，请重新点击安装';
        return (
          <div style={{ textAlign: 'center', color: '#409EFF' }}>
              确认地磁已重启后
            <a style={{ color: '#409EFF', textDecoration: 'underline' }} onClick={this.skip}>点击重新安装</a>
          </div>
        );
      }
      if (status === 'default') {
        if (Number(version) < Number(newVersion)) {
          return (
            <div style={{ textAlign: 'center' }}>
              <Button type="primary" onClick={this.onUpgrade}>{module}升级</Button>
            </div>
          );
        }
        if (upGradeType === '正在升级CPU1') {
          if (!isRebootCPU1) {
            // 正在重启CPU1
            titleTxt = 'CPU1正在重启...';
            return <div style={{ color: '#333', textAlign: 'center' }}>重启CPU1需要一定时间，请耐心等待</div>;
          }
          return '';
        }
      }
      if (status === 'loading') {
        titleTxt = '地磁版本升级中...';
        return (
          <div style={{ padding: '5px 0' }}>
            <Progress
              rate={progress}
            />
            <div style={{ textAlign: 'center', color: 'red' }}>{module}升级中，请勿退出</div>
          </div>
        );
      }
      if (status === 'fail') {
        titleTxt = '升级失败，请查看日志升级失败错误码';
        return (
          <div style={{ textAlign: 'center', color: 'red' }}>
            升级失败
            <a style={{ color: '#409EFF', textDecoration: 'underline' }} onClick={this.skip}>关闭</a>
          </div>
        );
      }
      return '';
    })();

    return (
      <div className="upgrade" style={{ display: showUpgrade ? 'block' : 'none' }}>
        <div className="upgrade-wrap">
          <div className="upgrade-title">{titleTxt}</div>
          {statusComp}
        </div>
      </div>
    );
  }
}

export default observer(UpgradeFrank);
